<template>
  <div :class="$style.box">
    Calling
    <h1>设计</h1>
    <h1>开发</h1>
    <h1>硬件</h1>
    <h1>测试</h1>
    <h1>编辑</h1>

    招募 设计类 开发者 硬件专家 测试工程师 文字编辑类
    更多职位请移步 boss指聘请
    <!-- {{ content.workEnviormentFulltime }} -->
    {{ content.workInvitation }}
    <br>
    {{ content.helloMail }}

    <div class="row">
      <!-- <div>工作地点 上海 / 深圳 / 不限 </div>
      <div>合约形式 全职 / 合作 </div>
      <div>工作领域 设计 / 工程 / 艺术 / 编辑</div> -->
    </div>

    <!-- <div :class="$style.cardList">
      {{ content.workEnviormentFulltime }}
      <div
        :class="$style.card"
        v-for="(job ,i) in jobs"
        :key="i"
      >
        <h2 :class="$style.cardTitle">{{ job.title }}</h2>
        <p>
          {{ job.location }}
        </p>
        <p>
          {{ job.tags }}
        </p>
        <p>
          {{ job.contract }}
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'JoinUs',
  props: ['content']

}
</script>

<style module>
.box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cardList {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}

.card{
  position: relative;

  /* display: inline-block; */

  padding: 24px;
  min-width: 360px;
  max-width: 360px;

  /* height: 500px; */
  margin: 12px;
  background: white;
}

.cardTitle {
  font-size: 24px;
}
</style>
